import type { FC } from 'react'

import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown'
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo'

import Icon from '@space-lib/components/icon'
import Table from '@space-lib/components/table'
import Tooltip from '@space-lib/components/tooltip'
import useTranslation from '@space-lib/hooks/useTranslation'

import { CustomButton, CustomIcon } from './styles'
import type { MemberListHeaderProps } from './types'

const MemberListHeader: FC<MemberListHeaderProps> = ({
  onClick,
  shouldRenderExpirationDate,
  isRemoveActionEnabled,
  isActiveOrder = { memberType: false, name: false },
  disabled = false
}) => {
  const { t } = useTranslation()

  return (
    <Table.Header>
      <Table.Head>
        <CustomButton disabled={disabled} onClick={() => onClick('name')}>
          <span>{t('configuration_sidebar.members_and_permissions.list.title_section.name')}</span>
          <CustomIcon $isActive={isActiveOrder.name} className='_ml-2' icon={faChevronDown} />
        </CustomButton>
      </Table.Head>
      {shouldRenderExpirationDate && (
        <Table.Head className='_align-middle _text-center'>
          <span>
            {t('configuration_sidebar.members_and_permissions.list.title_section.expiration_date')}
          </span>
          <Tooltip
            content={t(
              'configuration_sidebar.members_and_permissions.list.title_section.expiration_date_tooltip'
            )}>
            <Icon icon={faCircleInfo} className='_ml-2' />
          </Tooltip>
        </Table.Head>
      )}
      <Table.Head className='_align-middle _text-center'>
        {t('configuration_sidebar.members_and_permissions.list.title_section.role_2')}
      </Table.Head>
      {isRemoveActionEnabled && (
        <Table.Head className='_align-middle _text-center'>
          {t('configuration_sidebar.members_and_permissions.list.title_section.remove')}
        </Table.Head>
      )}
    </Table.Header>
  )
}

export default MemberListHeader
